import { API_URL } from "../const";

export default path => API_URL + "/" + path;